import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "src/components/button";
import Modal from "src/components/modal";

export const MobileWarnModal = () => {
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!isMobile) return null;

  return (
    <Modal noFooter>
      <div className="flex justify-center flex-col items-center gap-6">
        <div className="text-2xl">Optimal Viewing Experience</div>
        <div className="text-sm mx-10 text-center">
          TestRoom features are best accessed on laptops, desktops, and select
          tablets/iPads.{" "}
          <strong>Mobile devices are currently not supported</strong>. For the
          best experience, please use a compatible device.
        </div>
        <div className="flex flex-col gap-5">
          <Button onClick={() => navigate("/profile")}>Ok</Button>
        </div>
      </div>
    </Modal>
  );
};
